import { Controller } from "@hotwired/stimulus"

// A draft picks the same controls as a person, within this task's action area.
export default class extends Controller {
  static values = { key: String, value: String, detail: String, scope: String }

  pick() {
    if (!this.scopeValue) return
    const scope = this.element.closest(this.scopeValue)
    if (!scope) return
    const row = [...scope.querySelectorAll('[data-collection-review-target="row"]')]
      .find(element => element.querySelector('[data-choice]')?.name === `task_action[submission_payload][${this.keyValue}]`)
    if (!row) return

    const radios = [...row.querySelectorAll('[data-pick]')]
    const radio = radios.find(input => {
      const data = input.dataset
      if ((data.choiceValue || input.value) !== this.valueValue) return false
      if (data.pickDetail !== undefined) return data.pickDetail === this.detailValue
      return this.valueValue !== 'correct' || !radios.some(other => other.dataset.pickDetail === this.detailValue)
    })
    const check = this.valueValue === 'reviewed' ? row.querySelector('[data-check]') : null
    const combo = row.querySelector('[data-combo]')
    const option = combo && [...combo.querySelectorAll('[role="option"]')].find(element => element.dataset.value === this.valueValue)
    const control = radio || check
    if (control) {
      if (!control.checked) control.click()
    } else if (option) {
      option.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }))
    } else return

    const detail = row.querySelector('[data-detail]')
    if (detail && detail.value !== this.detailValue) {
      detail.value = this.detailValue
      detail.dispatchEvent(new Event('input', { bubbles: true }))
    }
    ;(control?.closest('label') || row).scrollIntoView({ block: 'center', behavior: 'smooth' })
    ;(control || combo.querySelector('[data-combo-input]')).focus({ preventScroll: true })
  }
}
